import { render, staticRenderFns } from "./dialogModule.vue?vue&type=template&id=10a504d3&scoped=true"
import script from "./dialogModule.vue?vue&type=script&lang=js"
export * from "./dialogModule.vue?vue&type=script&lang=js"
import style0 from "./dialogModule.vue?vue&type=style&index=0&id=10a504d3&prod&lang=scss&scoped=true"
import style1 from "./dialogModule.vue?vue&type=style&index=1&id=10a504d3&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a504d3",
  null
  
)

export default component.exports